import {
  DomainComponentState,
  QuickSizerRequest,
} from '../../feature-modules/quick-sizer/models/quick-sizer.models';

export class LoadQuickSizerConfigs {
  static readonly type = '[QuickSizer] Load Configs';
}

export class LoadQuickSizerHardwareBounds {
  static readonly type = '[QuickSizer] Load ReadyNode Hardware Bounds';
}

export class LoadQuickSizerComponents {
  static readonly type = '[QuickSizer] Load VCF Components';
}

export class SetQuickSizerComponents {
  static readonly type = '[QuickSizer] Set VCF Components';
  constructor(public readonly components: DomainComponentState[]) {}
}

export class PatchQuickSizerRequest {
  static readonly type = '[QuickSizer] Patch Request';
  constructor(public readonly request: QuickSizerRequest) {}
}

export class CalculateQuickSizerRecommendation {
  static readonly type = '[QuickSizer] Calculate Recommendation';
  constructor(public readonly request: QuickSizerRequest) {}
}

export class ResetQuickSizer {
  static readonly type = '[QuickSizer] Reset';
}
